<template>
  <div class="lk-video">
    <template v-if="normalizedItem">
      <iframe
        v-if="normalizedItem.type === 'iframe'"
        class="lk-video__video"
        :src="normalizedItem.src"
        allow="autoplay; encrypted-media; fullscreen; picture-in-picture; screen-wake-lock; clipboard-write"
        frameborder="0"
        loading="lazy"
        allowfullscreen
      ></iframe>
      <video
        v-else-if="normalizedItem.type === 'video'"
        class="lk-video__video"
        :src="normalizedItem.src"
        controls
        playsinline
        preload="metadata"
      ></video>
    </template>
    <div v-else class="lk-video__video lk-video__video--empty"></div>
  </div>
</template>

<script>
export default {
  props: {
    video: {
      type: String,
      required: true,
    },
  },
  computed: {
    normalizedItem() {
      return this.getVideoData(this.video)
    },
  },
  methods: {
    getVideoData(videoUrl) {
      if (!videoUrl || typeof videoUrl !== 'string') {
        return null
      }

      if (this.isIframeString(videoUrl)) {
        return this.parseIframeString(videoUrl)
      }

      if (this.isUrlString(videoUrl)) {
        return this.parseUrl(videoUrl)
      }

      return null
    },
    isIframeString(value) {
      return /<iframe/i.test(value)
    },
    isUrlString(value) {
      try {
        new URL(value)
        return true
      } catch (error) {
        return false
      }
    },
    parseIframeString(iframeString) {
      try {
        const parser = new DOMParser()
        const doc = parser.parseFromString(iframeString, 'text/html')
        const iframe = doc.querySelector('iframe')

        if (!iframe) {
          return null
        }

        const src = iframe.getAttribute('src')

        if (!src || !this.isAllowedIframeUrl(src)) {
          return null
        }

        return {
          type: 'iframe',
          src,
        }
      } catch (error) {
        console.error('Failed to parse iframe video:', error)
        return null
      }
    },
    parseUrl(url) {
      try {
        const parsedUrl = new URL(url)

        try {
          const vkVideoData = this.parseVkVideoUrl(parsedUrl)
          if (vkVideoData) {
            return vkVideoData
          }

          const rutubeVideoData = this.parseRutubeUrl(parsedUrl)
          if (rutubeVideoData) {
            return rutubeVideoData
          }

          const nxCloudVideoData = this.parseNxCloudUrl(parsedUrl)
          if (nxCloudVideoData) {
            return nxCloudVideoData
          }

          return null
        } catch (e) {
          console.error(e)
          return null
        }
      } catch (error) {
        console.error('Failed to parse video url:', error)
        return null
      }
    },
    parseVkVideoUrl(url) {
      const isVkVideoHost = url.origin.includes('vkvideo')
      const match = url.pathname.match(/video-(\d+)_(\d+)/)

      if (!isVkVideoHost || !match) {
        return null
      }

      const [_, ownerId, videoId] = match

      return {
        type: 'iframe',
        src: `${url.origin}/video_ext.php?oid=-${ownerId}&id=${videoId}&hd=1`,
      }
    },
    parseRutubeUrl(url) {
      const isRutubeHost = url.origin.includes('rutube')

      if (!isRutubeHost) {
        return null
      }

      return {
        type: 'iframe',
        src: `${url.origin}/play/embed${url.pathname}`,
      }
    },
    parseNxCloudUrl(url) {
      const isNxCloudHost = url.origin.includes('nxcloud.axoftglobal')

      if (!isNxCloudHost) {
        return null
      }

      return {
        type: 'video',
        src: `${url.toString()}/download`,
      }
    },
    isAllowedIframeUrl(url) {
      try {
        return new URL(url).hostname
      } catch (error) {
        return false
      }
    },
  },
}
</script>

<style lang="sass">
@import "~@src/assets/lk/styles/variables"

.lk-video
  margin-top: 40px
  border-radius: 6px
  overflow: hidden

  @media screen and (min-width: $desktop-big)
    margin-top: 48px

  &__video
    aspect-ratio: 16 / 9
    width: 100%
    max-height: 485px
    display: block

    @media screen and (min-width: $desktop-medium)
      max-height: 624px

    @media screen and (min-width: $desktop-big)
      max-height: 750px

    @media screen and (max-width: $desktop-small)
      max-height: 472px

    @media screen and (max-width: $tablet-size)
      max-height: 380px

    @media screen and (max-width: $mobile-size)
      max-height: 152px
</style>



// WEBPACK FOOTER //
// src/templates/components/lk/lk-video/lk-video.vue